export default "__VITE_ASSET__BERr4Urb__"